import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Chip from 'components/common/Chip';

import dateFormat from 'config/dateFormat';

const styles = theme => ({
  typography: {
    padding: '0 24px 3px 24px',
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
  chips: {
    margin: '0 -6px',
    padding: '6px 24px',
  },
  chip: {
    margin: 6,
    verticalAlign: 'top',
  },
});

const ProductClaimViewItemRefill = ({ Refill, Type, classes, ...otherProps }) => {
  const date = moment(otherProps['Date of Service From'], dateFormat);
  const dates = [];
  for (let i = 1; i <= Refill; i += 1) {
    const refillDate = Type === 'Recurring' 
      ? date.clone().add(i*30, 'days').format(dateFormat)
      : date.clone().add(i, 'month').format(dateFormat);
    dates.push(refillDate);
  }
  return (
    <Grid
      container
      justify="flex-start"
      wrap="nowrap"
      spacing={24}
    >
      <Grid item xs={12}>
        <Typography
          className={classes.typography}
          variant="subheading"
        >
          Future Refills
        </Typography>
        <div className={classes.chips}>
          {dates.map(item => (
            <Chip
              key={item}
              className={classes.chip}
              size="md"
              // borderColor="primary"
              label={item}
            />
          ))}
        </div>
      </Grid>
    </Grid>
  );
};

ProductClaimViewItemRefill.propTypes = {
  Refill: PropTypes.number.isRequired,
  'Date of Service From': PropTypes.string.isRequired,
  classes: PropTypes.shape({
    typography: PropTypes.string.isRequired,
    chips: PropTypes.string.isRequired,
    chip: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(ProductClaimViewItemRefill);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaimView/ProductClaimViewItemRefill.js